import { CancelToken } from 'axios';
import axios from './axios';

export const search = (data: BULLZ.QuerySearchRequest, cancelToken?: CancelToken) =>
    axios<BULLZ.QuerySearchResponse>({
        url: '/search',
        cancelToken,
        data
    });
